import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { findLink } from '../../../../LinkyLinky';
import { Link } from '../../../../Resource/Types';
import { T } from '../../../../Translations';
import ShareIcon from '../../../Cutesies/ShareIcon';

interface ShareButtonProps {
  onClick: () => void;
  collectionLinks: ReadonlyArray<Link>;
  intercomTarget?: string;
}

// Visibility is gated on the AdminStudio share privilege only.
// Previously this also required the per-item `publish` link, but that link
// is now hidden for v2 orgs (the v1 "Publish and Share" menu item was v1
// chrome). The share priv is the correct authority for this button — the
// classic publish/share flow and the AdminStudio share flow are separate.
// The `collectionLinks` prop is retained for compatibility with existing
// callers and for potential future per-item gating (e.g., "collection is
// in a shareable state").
const ShareButton: React.FC<ShareButtonProps> = ({
  onClick,
  collectionLinks: _collectionLinks,
  intercomTarget,
}) => {
  return (
    <>
      {findLink('adminstudio-share-learning-collections-share', currentUserStore.links)
        .map(() => (
          <button
            onClick={onClick}
            className="flex items-center gap-2 px-3 py-2 border border-primary text-primary rounded-md hover:bg-card transition-colors text-sm font-semibold"
            data-intercom-target={intercomTarget}
            title="Share Your Learning Collection"
          >
            <ShareIcon className="w-3 h-3" />
            <T kind="Share" />
          </button>
        ))
        .getOrElse(emptyFragment)}
    </>
  );
};

export default observer(ShareButton);
